<main class="w-full px-8 bg-white py-14 md:py-20 md:px-14">
    <fuse-alert
        *ngIf="showAlert"
        class="fixed z-50 top-4 right-5"
        [appearance]="'border'"
        [dismissible]="false"
        [showIcon]="true"
        [type]="alert.type"
        @fadeInRight>
        {{ alert.message }}
    </fuse-alert>
    <div class="relative flex items-center">
        <button
            class="absolute z-50 flex items-center justify-center w-4 h-4 border rounded-full md:w-6 md:h-6 border-primary -left-5 md:-left-8"
            (click)="goback()">
            <mat-icon
                class="w-[5px] h-[3px] mr-[1px] min-w-[5px] min-h-[3px] md:w-[7.5px] md:h-[4.5px] md:min-w-[7.5px] md:min-h-[4.5px] text-primary rotate-90"
                svgIcon="icons:arrow-icon">
            </mat-icon>
        </button>
        <h1 class="text-black title-6 md:title-3">Editor plantilla</h1>
    </div>

    <mat-form-field class="w-full h-[5rem] mt-5" hideRequiredMarker>
        <mat-label>Nombre de plantilla</mat-label>
        <input
            matInput
            type="text"
            [(ngModel)]="infoPlantilla.name"
            placeholder="Nombre Plantilla"
            class="h-[26px]"
            maxlength="30"
            pattern="^[a-zA-Z0-9ñÑáéíóúÁÉÍÓÚ ]{1,30}$"
            required
            #nombrePlantilla="ngModel" />
    </mat-form-field>

    <!-- EDITOR -->
    <div class="py-5">
        <editor [(ngModel)]="infoPlantilla.body" [init]="init" #editor="ngModel" required> </editor>
    </div>

    <div class="flex items-center gap-5 p-4 my-5 rounded-lg bg-primary-gray-02">
        <mat-icon class="w-[20px] h-[20px] min-w-[20px] min-h-[20px] self-start" svgIcon="icons:info-icon"> </mat-icon>
        <p class="paragraph-4 text-primary-black-01">
            Puedes ingresar variables para mostrar datos del sistema,
            <span class="cursor-pointer text-primary-blue-01" (click)="modalVariables = true">conoce las variables.</span>
        </p>
    </div>
    <button
        mat-flat-button
        color="primary"
        class="w-full md:w-48"
        [disabled]="guardando || !nombrePlantilla.valid || !editor.valid"
        (click)="guardarPlantilla()">
        <span *ngIf="!guardando"> Guardar </span>
        <mat-progress-spinner *ngIf="guardando" [diameter]="24" [mode]="'indeterminate'"> </mat-progress-spinner>
    </button>
</main>

<!-- Modal Variables -->
<div *ngIf="modalVariables" class="fixed inset-0 grid w-full h-full p-5 bg-opacity-50 bg-primary-black-01 z-99999 place-items-center">
    <div
        class="w-full max-w-[597px] h-full max-h-[620px] md:max-h-[640px] bg-primary-white-01 rounded-2xl px-10 py-8 md:px-16 md:pt-14 md:pb-10 relative overflow-auto no-scrollbar">
        <button
            class="absolute top-4 right-3 md:right-14 flex gap-3 items-center text-primary-blue-01 font-bold text-[10px]"
            (click)="modalVariables = false">
            CERRAR
            <div class="flex items-center justify-center w-6 h-6 mx-auto border rounded-full border-primary-blue-01">
                <mat-icon class="w-[7.4px] h-[7.4px] min-w-[7.4px] min-h-[7.4px]" svgIcon="icons:close-icon"> </mat-icon>
            </div>
        </button>
        <h1 class="mt-5 title-8">Variables disponibles para personalizar la plantilla</h1>
        <div class="justify-between hidden mt-10 md:flex">
            <table>
                <thead>
                    <tr>
                        <th>Variable</th>
                        <th>Descripción</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let variable of variablesPersonalizacion" class="my-1">
                        <td>{{ '&#123;&#123;' + variable.NOMBRE + '&#125;&#125;' }}</td>
                        <td>{{ variable.DESCRIPCION }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="flex justify-between mt-5 md:hidden">
            <div class="flex flex-col gap-3 text-black paragraph-4">
                <p class="paragraph-3">Variable</p>
                <ng-container *ngFor="let variable of variablesPersonalizacion">
                    <p>{{ '&#123;&#123;' + variable.NOMBRE + '&#125;&#125;' }}</p>
                    <p>{{ variable.DESCRIPCION }}</p>
                </ng-container>
            </div>
        </div>
    </div>
</div>
